export const customPromptTemplates = [
  {
    name: 'Prompt 1',
    fields: [
      "Company Name",
      "One-Line Description",
      "Industry / Sector",
      "Location",
      "Deal Source",
      "Funding Round",
      "CEO / Founder Name",
      "Previous Funding",
      "Revenue"
    ],
  },
  {
    name: 'Prompt 2',
    fields: [
      "Company Name 2",
      "One-Line Description 2",
      "Industry / Sector 2",
      "Location 2",
      "Deal Source 2",
      "Funding Round 2",
      "CEO / Founder Name 2",
      "Previous Funding 2",
      "Revenue 2"
    ],
  },
  {
    name: 'Prompt 3',
    fields: [
      "Company Name 3",
      "One-Line Description 3",
      "Industry / Sector 3",
      "Location 3",
      "Deal Source 3",
      "Funding Round 3",
      "CEO / Founder Name 3",
      "Previous Funding 3",
      "Revenue 3"
    ],
  },
]

export const companyDetailsJsonTemplate = {
  "file_id": "8f968de0-886f-4f31-be5e-fe41913f8eed",
  "summary": {
    "DealBackground": "Directly sourced deal in market for a $27.2mm round with participation from existing investors; Use of proceeds includes (1) accelerate in private equity market across the U.S., EMEA, and Middle East and (2) extend into private credit/debt/hybrid/retail.",
    "CompanyOverview": {
      "Name": "Outbox PVT LTD",
      "Founded": "2021",
      "Headquarters": "N/A",
      "Industry": "Accounting for Private Markets",
      "Product": "Next-generation accounting platform that digitizes and automates fund and investor accounting."
    },
    "MarketAndCompetition": "Outbox operates in a landscape characterized by outdated legacy systems for fund accounting, growth in the private markets, and increased structural complexity of funds. The company faces headwinds such as entrenched incumbents, high switching costs, and conservative buyer personas (primarily CFOs). Major competitors include Investran, eFront, Allvue, and FundGuard.",
    "InvestmentSummary": "Outbox raised $70.2mm of capital to date, which includes both seed preferred equity rounds from Feb 2023 to Oct 2024 and SAFEs. The company is looking to raise a $22.2mm round to accelerate in private equity market across the U.S., E.M.E.A., and Middle East.",
    "RevenueModel": "User-based or AUM-based SaaS model with implementation fees. 12% of revenue comes from software and 55% comes from implementation, with a focus on strong topline growth despite a long sales process and implementation costs' adverse impact on margins.",
    "Customers": "Goldman Sachs, Apollo, Blackstone",
    "Transaction": {
      "OverallTransactions": {
        "Columns": [
          "Metric",
          "Value"
        ],
        "Data": [
          {
            "Metric": "Total Capital Raised",
            "Value": "70.2mm"
          },
          {
            "Metric": "Current Round Size",
            "Value": "27.2mm"
          },
          {
            "Metric": "Target Raise",
            "Value": "22.2mm"
          }
        ]
      },
      "AnnualTransactions": {
        "Columns": [
          "AnnualPLSummary",
          "FY2022",
          "FY2023",
          "FY2024",
          "FY2025",
          "FY2026",
          "FY2027"
        ],
        "Data": [
          {
            "Metric": "ARR",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "8bn",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "%Growth",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "200%",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "Revenue",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "SoftwareRevenue",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "ImplementationRevenue",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "Other",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "TotalRevenue",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "%Growth",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "COGS-Software",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "COGS-Implementation",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "TotalCOGS",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "GrossProfit",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "%Margin-Software",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "%Margin-Implementation",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "%Margin-Total",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "OPEX",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "R&D",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "S&A",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "TotalOPEX",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "EBITDA",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "%Margin",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "MagicNumber",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          },
          {
            "Metric": "ReturnOnBurn",
            "FY2022": "N/A",
            "FY2023": "N/A",
            "FY2024": "N/A",
            "FY2025": "N/A",
            "FY2026": "N/A",
            "FY2027": "N/A"
          }
        ]
      }
    }
  },
  "pipeline_json": {
    "Deal_Information": {
      "Deal_Source": "Directly sourced deal",
      "Contact_Date": null,
      "Sector": "Private Markets",
      "Geography": "U.S., EMEA, and Middle East",
      "Risk_Rating": null
    },
    "Deal_Progress": {
      "Current_Stage": null,
      "Expected_Close": "Q1/2 2025",
      "Probability": null,
      "Lead_Investor": null,
      "Amount": 27200000
    },
    "Key_Metrics": {
      "ARR": 8000000,
      "Growth_Rate": 200,
      "Customers": 45,
      "Churn_Rate": null,
      "NPS_Score": null
    }
  },
  "risk_summary": {
    "title": "High Dependency on Legacy Systems and Competitive Repositioning Risk",
    "description": "Outbox PVT LTD faces risks related to their positioning in a highly competitive market dominated by legacy systems and entrenched incumbents, which could impact growth projections and market penetration.",
    "risk_category": "Competitive Risk",
    "risk_level": "High",
    "flagged_sections": [
      "Outdated legacy systems for fund accounting",
      "Entrenched incumbents",
      "High switching costs",
      "Conservative buyer personas (primarily CFOs)"
    ],
    "sections": [
      {
        "heading": "Market Competition",
        "subsections": [
          {
            "subheading": "Dependence on Legacy Systems",
            "content": "The document highlights significant reliance on outdated legacy systems, which poses a risk as more companies shift to modern solutions. This reliance could limit Outbox's prospects in penetrating the market against competitors like Investran and eFront, who dominate with established client bases and products."
          }
        ]
      },
      {
        "heading": "Customer Dynamics",
        "subsections": [
          {
            "subheading": "Conservative Buyer Profiles",
            "content": "The preference of firms for conservative buyer personas, namely CFOs, can hinder rapid adoption of new technologies. The lengthy sales processes further exacerbate this risk, potentially impacting revenue and operational efficiency."
          }
        ]
      },
      {
        "heading": "Financial Health",
        "subsections": [
          {
            "subheading": "Implementation Costs Impact",
            "content": "Implementation costs may adversely affect margins. As the company's revenue model heavily depends on user-based and AUM-based models, any downturn in client acquisition could lead to significant financial distress."
          }
        ]
      }
    ]
  }
}

export const pipelineDataTemplate = {
  "Deal_Information": {
    "Deal_Source": "Directly sourced deal",
    "Contact_Date": null,
    "Sector": "Private Equity, Private Credit, Hybrid, Retail",
    "Geography": "U.S., EMEA, Middle East",
    "Risk_Rating": null
  },
  "Deal_Progress": {
    "Current_Stage": "In market for a $19.2mm round",
    "Expected_Close": "Q1/2 2025",
    "Probability": null,
    "Lead_Investor": null,
    "Amount": "19.2mm"
  },
  "Key_Metrics": {
    "ARR": "~$1 bn (Debt TAM), ~$1 bn (Equity TAM), ~$1.6 bn (Small GPs)",
    "Growth_Rate": "+263%*",
    "Customers": "30 signed clients (as of March 2025)",
    "Churn_Rate": null,
    "NPS_Score": null
  }
}

export const transactionJSONTemplate = {
  "columns": [
    "Annual P&L Summary",
    "FY 2022",
    "FY 2023",
    "FY 2024",
    "FY 2025",
    "FY 2026",
    "FY 2027"
  ],
  "data": [
    {
      "metric": "ARR",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "% Growth",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Revenue",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Software Revenue",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Implementation Revenue",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Other",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Total Revenue",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "% Growth",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "COGS - Software",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "COGS - Implementation",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Total COGS",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Gross Profit",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "% Margin - Software",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "% Margin - Implementation",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "% Margin - Total",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "OPEX",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "R&D",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "S&M",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "G&A",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Total OPEX",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "EBITDA",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "% Margin",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Magic Number",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    },
    {
      "metric": "Return on Burn",
      "FY 2022": "N.A",
      "FY 2023": "N.A",
      "FY 2024": "N.A",
      "FY 2025": "N.A",
      "FY 2026": "N.A",
      "FY 2027": "N.A"
    }
  ]
}